import { render, staticRenderFns } from "./IconGermany.vue?vue&type=template&id=6ec8c992&"
import script from "./IconGermany.vue?vue&type=script&lang=ts&"
export * from "./IconGermany.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports